import type { FC } from 'react';
import type { TaskIndexProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import { isEmpty } from 'lodash-es';
import useRulePageMode from '../../hooks/useRulePageMode';
import tasksFormValidation from '../../utils/tasksFormValidation';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import VariantsEmptyState from './VariantsEmptyState';
import VariantsOnTask from './VariantsOnTask';

const RuleEditVariantsOnTask: FC<TaskIndexProps> = observer(({ indexTask }) => {
  const tasksFormStore = useCurrentTasksFormStore();

  const variantsOnTask = tasksFormStore.getVariantsOnTask(indexTask);
  const isVariants = !isEmpty(variantsOnTask);
  const { isRead } = useRulePageMode();
  const { isAddTaskAvailable } = tasksFormValidation({ tasksForm: tasksFormStore.tasksForm, indexTask });

  const handleAddVariantOnTask = () => {
    tasksFormStore.addVariantOnTask(indexTask);
  };

  return isVariants ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography component="span" sx={(t) => ({ typography: t.typography.h4, display: 'inline-flex', gap: 0.5 })}>
        Variants of Task {indexTask + 1}
      </Typography>
      {variantsOnTask.map((item, indexVariant) => (
        <VariantsOnTask
          key={`Task:${indexTask}.Variant:${indexVariant}.Dependencies:${item.__selectedDependenciesOnConditions.join(',')}`}
          indexTask={indexTask}
          indexVariant={indexVariant}
        />
      ))}
      <Box>
        <Button
          size="medium"
          startIcon={<AddIcon />}
          variant="text"
          onClick={handleAddVariantOnTask}
          disabled={!isAddTaskAvailable || isRead}
        >
          Add variant
        </Button>
      </Box>
    </Box>
  ) : (
    <VariantsEmptyState indexTask={indexTask} />
  );
});

export default RuleEditVariantsOnTask;
